import baseUrl from './baseUrl'
const { path } = baseUrl.path() // 开发与生产
import organ from './module/organ.js';
import pageRun from './module/page-run.js'
import resourceMonitoring from './module/resource-monitoring.js'

const api = {
  login: `${path}/uc`, // 新的登录接口
  getMessageCode: `${path}/uc/captcha/sendMsgCaptcha`, // 获取短信验证码
  changeCurrentOrgan: `${path}/uc/user/changeCurrentOrgan`, // 切换单位
  register: `${path}/uc/user/register`, // 注册账户
  forgetPwd: `${path}/uc/user/forgetPwd`, // 忘记密码
  menuList: path + '/uc/userExtend/menu', // 获取用户菜单
  password: path + '/uc/userExtend/user/password', // 登录
  updateUserPwd: path + '/uc/user/password', // 更新用户密码
  dictionary_collectione: path + '/uc/sysDicItem/findList', // 获取字典集
  upload_form_image: path + '/form-new/fileUploadRecord/image', // 表单上传图片
  delete_file_image: path + '/form-new/fileUploadRecord/', //删除文件
  database_component_list: path + '/form-new/component/listApplicationBindApiComponent', // 数据资产可以选择的组件列表
  staff_avatar: path + '/uc/staff/avatar', //上传头像
  staff_pageCurrentDeptStaff: path + '/uc/staff/pageCurrentDeptStaff', //获取部门成员
  organ_getAllOrganDeptTree: path + '/uc/organ/getAllOrganDeptTree', //获取组织数据
  fetch_sub_area: path + '/uc/area/listSubArea', // 省市区获取地址
  fetch_industry_info: path + '/uc/industry/getIndustryInfoTree', // 获取行业类别
  create_org_account: path + '/uc/organ/userOpenOrganAccount', // 用户创建组织账户
  dict_list: path + '/uc/dict/data/list', // 按字典类型查询字典列表
  get_user_manage_application: path + '/form-new/formApp/listCurrentStaffManageApplicationId', // 列出当前员工管理的应用id
  // get_user_config: path + '/form-new/userWorkbenchConfig/getUserConfig', //获取用户配置 get
  get_user_permission: path + '/uc/resource/getResourcePermission', //获取用户权限
  get_uc_verify_login: path + '/uc/verifyLoginStatus', //校验token

  // 日志管理
  get_platform_log: path + '/form-new/log/platform', // 获取平台日志
  get_application_log: path + '/form-new/log/application', // 获取应用日志
  get_product_log: path + '/form-new/log/product', // 获取产品日志
  get_operation_type: path + '/form-new/log/model', // 获取操作类型
  get_product_list: path + '/form-new/product/listStaffProduct', // 获取产品列表
  get_application_list: path + '/form-new/formApp/listStaffApplication', // 获取应用列表
  //组织用户角色
  organ,
  pageRun,
  resourceMonitoring,
};

window.API = api

export default {
  install(Vue) {
    Vue.prototype.$API = api
  }
}
